import React, { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { Route, Routes } from 'react-router-dom';
import { PointsActions } from '@/stores/slice/pointsSlice';
import store, { useAppSelector } from '@/stores';
import { fetchUserPoints2, getStudentInfoAsync } from '@/stores/slice/user';
import MockStart from './subPage/MockStart';
import MockListening from './subPage/MockListening';
import MockReading from './subPage/MockReading';
// import MockWritingAI from './subPage/MockWritingAI';
import MockWriting from './subPage/MockWriting';
import { Redirect } from './components/Redirect';
import ClientExamGuard from './components/ClientExamGuard';
import './index.less';


// /:id
function App() {
  const routerConf = React.useMemo(() => {
    return [
      { path: '/mockstart/:recordId', Component: MockStart },
      { path: '/mocklistening/:recordId', Component: () => <ClientExamGuard course="listening"><MockListening /></ClientExamGuard>},
      { path: '/mocklisteningai/:recordId', Component: MockListening},
      { path: '/mockreading/:recordId', Component: () => <ClientExamGuard course="reading"><MockReading /></ClientExamGuard>},
      { path: '/mockreadingai/:recordId', Component: MockReading},
      { path: '/mockwriting/:recordId', Component: () => <ClientExamGuard course="writing"><MockWriting /></ClientExamGuard>},
      { path: '/mockwritingai/:recordId', Component: MockWriting},
      { path: '/*', loader: () => <></>, Component: Redirect },
    ];
  }, []);

  const isLogin = useAppSelector(state => state.user.userPermission.isLogin);

  useEffect(() => {
    store.dispatch(getStudentInfoAsync());
  }, []);

  useEffect(() => {

    if (isLogin) {
      store.dispatch(PointsActions.fetchPoints());
      store.dispatch(fetchUserPoints2());
    }
  }, [isLogin]);

  return (
    <>
      <Routes>
        {
          routerConf.map((item) => {
            return <Route key={item.path} path={item.path} Component={item.Component} />;
          })
        }
      </Routes>
      <Toaster />
    </>
  );
}

export default App;
